import React, { Component } from 'react'

class RenderTagsInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			inputValue: '',
			tags: this.props.input.value ? (Array.isArray(this.props.input.value) ? this.props.input.value : this.props.input.value.split(',').filter(tag => tag.trim() !== '')) : []
		};
	}

	componentDidUpdate(prevProps) {
		// Sync with form value changes
		if (prevProps.input.value !== this.props.input.value) {
			const newTags = this.props.input.value ? 
				(Array.isArray(this.props.input.value) ? this.props.input.value : this.props.input.value.split(',').filter(tag => tag.trim() !== '')) : [];
			if (JSON.stringify(newTags) !== JSON.stringify(this.state.tags)) {
				this.setState({ tags: newTags });
			}
		}
	}

	handleInputChange = (e) => {
		this.setState({ inputValue: e.target.value });
	}

	handleKeyDown = (e) => {
		if (e.key === 'Enter' && this.state.inputValue.trim() !== '') {
			e.preventDefault();
			this.addTag(this.state.inputValue.trim());
		}
	}

	addTag = (tag) => {
		if (!this.state.tags.includes(tag)) {
			const newTags = [...this.state.tags, tag];
			this.setState({ 
				tags: newTags, 
				inputValue: '' 
			});
			// Update form value
			this.props.input.onChange(newTags);
		} else {
			this.setState({ inputValue: '' });
		}
	}

	removeTag = (indexToRemove) => {
		const newTags = this.state.tags.filter((_, index) => index !== indexToRemove);
		this.setState({ tags: newTags });
		// Update form value
		this.props.input.onChange(newTags);
	}

	render() {
		const {
			label,
			labelClass,
			placeholder,
			customColor = '#564FDB'
		} = this.props;

		return (
			<div>
				<label className={labelClass}>{label}</label>
				<div className="tags-input-container" style={{ 
					border: '1px solid #ddd', 
					borderRadius: '4px', 
					padding: '8px',
					minHeight: '40px',
					backgroundColor: '#fff',
					display: 'flex',
					flexWrap: 'wrap',
					alignItems: 'center',
					gap: '4px'
				}}>
					{this.state.tags.map((tag, index) => (
						<div 
							key={index} 
							className="tag-item" 
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								backgroundColor: 'transparent',
								border: `2px solid #B3D9FF`,
								borderRadius: '5px',
								fontSize: '14px',
								marginRight: '4px',
								marginBottom: '4px',
								overflow: 'hidden'
							}}
						>
							<button
								type="button"
								onClick={() => this.removeTag(index)}
								style={{
									background: '#edf5fe',
									border: 'none',
									borderRight: `2px solid #B3D9FF`,
									color: '#999',
									cursor: 'pointer',
									fontSize: '14px',
									fontWeight: 'bold',
									padding: '6px 8px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '100%',
									minHeight: '28px'
								}}
							>
								×
							</button>
							<span style={{
								color: '#999',
								padding: '6px 8px',
								backgroundColor: '#edf5fe',
								height: '100%',
								display: 'flex',
								alignItems: 'center',
								minHeight: '28px'
							}}>
								{tag}
							</span>
						</div>
					))}
					<input
						type="text"
						value={this.state.inputValue}
						onChange={this.handleInputChange}
						onKeyDown={this.handleKeyDown}
						placeholder={this.state.tags.length === 0 ? placeholder : ''}
						style={{
							border: 'none',
							outline: 'none',
							flex: '1',
							minWidth: '120px',
							fontSize: '14px',
							padding: '4px',
							backgroundColor: 'transparent',
							boxShadow: 'none'
						}}
					/>
				</div>
			</div>
		);
	}
}

export default RenderTagsInput;